import { Flow, Stream, Text as Tx, } from "@bracket/ui";
import { EthAddress, VaultLogo } from "@components";
import styled from "styled-components";
import type { Vault, } from "@bracket/types";



export declare type VaultTitleProps = {
	vault: Vault;
};


export const VaultTitle = ({ vault,  }: VaultTitleProps) => {
	const { symbol, title, address } = vault;
	return (
		<TopTitleFrame>
			<TopTitle>
				<Ident>
					<VaultLogo vault={vault} height="55px" opacity={0.65} top="30px" />
					<Tx h4 color="heading">{symbol}</Tx>
				</Ident>
				<Tx font="body" weight="500" size="xl" color="heading">{title}</Tx>
				{/* <EthAddress address={address} justify="start" size="0.85rem" explorer /> */}
			</TopTitle>
		</TopTitleFrame>
	);
};


const TopTitleFrame = styled(Stream)`
	align-items: flex-start;
	justify-content: flex-start;
	height: 100%;
`;

const TopTitle = styled(Flow)`
	gap: 0.25rem;
`;

const Ident = styled(Stream)`
	align-items: center;
	gap: 16px;
	> h4 {
	 line-height: 2rem;
	}

	// desktop below.
	@media (min-width: 768px) {

	}
`;
